import React, { useState } from "react";
import {
  Home,
  UserPlus,
  ClipboardCheck,
  DoorOpen,
  ChevronLeft,
  Pickaxe,
  CircleDollarSign,
  GraduationCap,
  Drill,
  Truck,
  Settings,
  LucideFileLineChart,
} from "lucide-react";
import logoLisual from "../../media/lisualpro.png";
import defaultLogo from "../../media/lisualLogo.jpg";
import { useNavigate } from "react-router-dom";
import NewProject from "../../customerDashboard/components/NewProject.tsx";
import PaymentModal from "../../customerDashboard/components/PaymentModal.tsx";
import OnboardingSchedule from "../../customerDashboard/components/OnboardingSchedule.tsx";
import InstallationSchedule from "../../customerDashboard/components/InstallationSchedule.tsx";
import CamDelivery from "../../customerDashboard/components/CamDelivery.tsx";
import CustomerConfig from "../../customerDashboard/components/EditCustomer.tsx";
import CustomerUsers from "../../customerDashboard/components/CustomerUsers.tsx";

const CustomerSidebar = ({
  isSidebarOpen,
  toggleSidebar,
  activeTab,
  setActiveTab,
  logo,
  customerId,
  onProjectCreated,
  customerData
}) => {
  const navigate = useNavigate();
  const [showNewProjectModal, setShowNewProjectModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showOnboardingModal, setShowOnboardingModal] = useState(false);
  const [showInstallationModal, setShowInstallationModal] = useState(false);
  const [showCameraSetupModal, setShowCameraSetupModal] = useState(false);
  const [showCustomerConfigModal, setShowCustomerConfigModal] = useState(false);
  const [showUsersModal, setShowUsersModal] = useState(false);
  const [onUserCreated, setOnUserCreated] = useState(false);

  const navigateToPage = (page) => {
    //navigate(`/metrics/${customerId}/${customerData.identifier}/`);
    navigate(`/metrics/0/0/`);
  };

  const allMenuItems = [
    { name: "Inicio", icon: <Home size={24} />, disabled: false },
    /*{ name: "Capacitación", icon: <GraduationCap size={24} />, disabled: false },
    { name: "Envío de Cámara", icon: <Truck size={24} />, disabled: false },
    { name: "Instalación", icon: <Drill size={24} />, disabled: false },
    { name: "Usuarios", icon: <UserPlus size={24} />, disabled: false },
    //{ name: "Análisis IA", icon: <LucideFileLineChart size={24} />, disabled: false },
    { name: "Terminados", icon: <ClipboardCheck size={24} />, disabled: true },
    { name: "Configuración", icon: <CustomerConfig size={24} />, disabled: false },
     */
  ];

  const menuItems = allMenuItems.filter(item => {
    //if (item.name === "Análisis IA") {
    //  const allowedCustomers = ["tecpetrol05122025", "safiar15122025"];
    //  return allowedCustomers.includes(customerId?.toLowerCase());
    //}
    return true; 
  });

  
  const handleImageError = (e) => {
    e.target.src = defaultLogo;
  };

  const handleMenuClick = (itemName) => {
    if (itemName === "Alta Cámara") {
      setShowNewProjectModal(true);
    } else if (itemName === "Abonar") {
      setShowPaymentModal(true);
    } else if (itemName === "Capacitación") {
      setShowOnboardingModal(true);
    } else if (itemName === "Instalación") {
      setShowInstallationModal(true);
    } else if (itemName === "Envío de Cámara") {
      setShowCameraSetupModal(true);
    } else if (itemName === "Configuración") {
      setShowCustomerConfigModal(true);
    } else if (itemName === "Usuarios") {
      setShowUsersModal(true);
    } else if (itemName === "Análisis IA") {
      navigateToPage();
    } else {
      setActiveTab(itemName);
    }
  };

  return (
    <>
      <aside
        className={`
          hidden lg:block fixed inset-y-0 left-0 z-30 transition-all duration-300 ease-in-out
          bg-gradient-to-br from-blue-200 via-blue-100 to-white border-r border-blue-200 shadow-lg overflow-y-auto
          ${isSidebarOpen ? "w-64" : "w-0"}
        `}
      >
        <div className="p-6 bg-blue-100">
          {logo ? (
            <img
              src={logo}
              alt="Logo"
              className="h-40 w-auto mx-auto mb-6"
              style={{ borderRadius: "10%" }}
              onError={handleImageError}
            />
          ) : (
            <img
              src={defaultLogo}
              alt="Logo Lisual"
              className="h-40 w-auto mx-auto mb-6"
              style={{ borderRadius: "10%" }}
            />
          )}
        </div>

        <nav className="px-4">
          <ul className="space-y-3">
            {menuItems.map((item) => (
              <li
                key={item.name}
                className={`
                  transition-all duration-200
                  ${activeTab === item.name && !item.disabled
                    ? "bg-white text-blue-800 shadow-md border-2 border-blue-300"
                    : item.disabled
                    ? "bg-gray-100 text-gray-400 cursor-not-allowed border border-gray-200"
                    : "bg-white/80 hover:bg-white text-gray-700 hover:text-blue-700 border border-blue-100"
                  }
                  rounded-xl backdrop-blur-sm
                `}
                onClick={() => !item.disabled && handleMenuClick(item.name)}
              >
                <div
                  className={`flex items-center p-3 ${item.disabled ? "opacity-50" : "cursor-pointer"}`}
                >
                  <span
                    className={`${
                      activeTab === item.name && !item.disabled
                        ? "text-blue-600"
                        : "text-gray-500"
                    }`}
                  >
                    {item.icon}
                  </span>
                  <span className="ml-3 font-medium">{item.name}</span>
                </div>
              </li>
            ))}
            <li className="pt-4 mt-4 border-t border-blue-200">
              <button
                onClick={
                  () => {
                    navigate("/");
                    localStorage.clear();
                  }}
                className="w-full flex items-center p-3 bg-white/80 text-red-600 hover:bg-white rounded-xl transition-colors border border-blue-100"
              >
                <DoorOpen />
                <span className="ml-3 font-medium">Salir</span>
              </button>
            </li>
          </ul>
        </nav>
        

        <div className="p-6">
          <img src={logoLisual} alt="Logo Lisual" className="h-12 w-auto ml-auto" />
        </div>
      </aside>

      {/* Mobile sidebar */}
      {isSidebarOpen && (
        <div className="lg:hidden fixed inset-0 z-50">
          <div
            className="absolute inset-0 bg-black/30 backdrop-blur-sm transition-opacity duration-300"
            onClick={() => toggleSidebar(false)}
          />
          <div className="absolute inset-y-0 left-0 w-[85%] max-w-sm bg-gradient-to-r from-blue-100 to-white shadow-xl">
            <div className="flex flex-col h-full">
              <div className="p-6 border-b border-blue-100">
                <div className="flex items-center justify-between">
                  <img
                    src={logo}
                    alt="Logo"
                    className="h-8 w-auto"
                    onError={handleImageError}
                  />
                  <button
                    onClick={() => toggleSidebar(false)}
                    className="p-2 rounded-lg hover:bg-blue-50 transition-colors"
                  >
                    <ChevronLeft size={24} className="text-gray-600" />
                  </button>
                </div>
              </div>

              <nav className="flex-1 overflow-y-auto p-4 space-y-2">
                {menuItems.map((item) => (
                  <button
                    key={item.name}
                    onClick={() => {
                      if (!item.disabled) {
                        handleMenuClick(item.name);
                        toggleSidebar(false);
                      }
                    }}
                    className={`
                      w-full flex items-center p-4 rounded-xl transition-all duration-200
                      ${activeTab === item.name
                        ? "bg-white text-blue-600 shadow-md border border-blue-100"
                        : "hover:bg-white/80 text-gray-600"
                      }
                    `}
                    disabled={item.disabled}
                  >
                    {React.cloneElement(item.icon, { size: 20, className: "flex-shrink-0" })}
                    <span className="ml-3 font-medium truncate">{item.name}</span>
                    {activeTab === item.name && (
                      <span className="ml-auto w-2 h-2 bg-blue-500 rounded-full" />
                    )}
                  </button>
                ))}

                <button
                  onClick={() => navigate("/")}
                  className="w-full flex items-center p-4 mt-6 text-red-600 border-t border-blue-100"
                >
                  <DoorOpen size={20} className="flex-shrink-0" />
                  <span className="ml-3 font-medium">Salir</span>
                </button>
              </nav>
            </div>
          </div>
        </div>
      )}

      {/* New Project Modal */}
      <NewProject
        isOpen={showNewProjectModal}
        onClose={() => setShowNewProjectModal(false)}
        customerId={customerId}
        onSave={(project) => {
          console.log("Proyecto guardado:", project);
          setShowNewProjectModal(false);
          onProjectCreated();
        }}
      />

      {/* Payment Modal */}
      {
      <PaymentModal
        isOpen={showPaymentModal}
        onClose={() => setShowPaymentModal(false)}
        customerId={customerId}
        onConfirm={(payment) => {
          console.log("Pago configurado:", payment);
          setShowPaymentModal(false);
        //onProjectCreated();
        }}
      />

      }

      {/* Onboarding Modal */}
      <OnboardingSchedule
        isOpen={showOnboardingModal}
        onClose={() => setShowOnboardingModal(false)}
        customerId={customerId}
        onConfirm={(schedule) => {
          console.log("Capacitación programada:", schedule);
          setShowOnboardingModal(false);
        }}
      />

      {/* Installation Modal */}
      <InstallationSchedule
        isOpen={showInstallationModal}
        onClose={() => setShowInstallationModal(false)}
        customerId={customerId}
        onConfirm={(schedule) => {
          console.log("Instalación programada:", schedule);
          setShowInstallationModal(false);
        }}
      />

      {/* Users Modal */}
      <CustomerUsers
        isOpen={showUsersModal}
        onClose={() => setShowUsersModal(false)}
        customerId={customerId}
        onSave={(user) => {
          console.log("Usuario guardado:", user);
          setShowUsersModal(false);
          onUserCreated();
        }}
      />  

      {/* Camera Delivery Modal */}
      <CamDelivery
        isOpen={showCameraSetupModal}
        onClose={() => setShowCameraSetupModal(false)}
        customerId={customerId}
        onConfirm={(delivery) => {
          console.log("Entrega de cámara programada:", delivery);
          setShowCameraSetupModal(false);
        }}
      />
      

            {/* Settings*/}
      <CustomerConfig
        isOpen={showCustomerConfigModal}
        onClose={() => setShowCustomerConfigModal(false)}
        customerId={customerId}
        customerData={customerData}
        onConfirm={(delivery) => {
          console.log("Settings:", delivery);
          setShowCustomerConfigModal(false);
        }}
      />
      




    </>
  );
};

export default CustomerSidebar;
